import React from 'react';
import { useAlgoliaAppInfo } from 'hooks';

export default Component => props => (
    <Component {...props} algoliaAppInfo={useAlgoliaAppInfo()} />
);
